import React, { useState } from "react";
import { Modal, Button, Form, Input, Select, message } from "antd";
import { KEYS, KEYS_TEST } from "./index";
import axios from "axios";
import localhost from "../../constants/localhost";

export default ({ mode, detail, getData }) => {
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const modalTitle = mode === "create" ? "新增权限" : "编辑权限";
  const operationText = mode === "create" ? "新增权限" : "编辑权限";

  return (
    <>
      {mode === "create" && (
        <Button type="primary" onClick={() => setVisible(true)}>
          {operationText}
        </Button>
      )}
      {mode === "edit" && (
        <a
          onClick={() => {
            setVisible(true);
            form.setFieldsValue(detail);
          }}
        >
          编辑
        </a>
      )}

      <Modal
        title={modalTitle}
        open={visible}
        onCancel={() => {
          setVisible(false);
        }}
        onOk={() => {
          // 提交表单
          form
            .validateFields()
            .then((values) => {
              axios
                .post(`${localhost}/manage/authority/save`, {
                  ...(detail || {}),
                  ...values,
                })
                .then((res) => {
                  message.success(
                    `${mode === "edit" ? "编辑" : "新增"}权限成功！`
                  );
                  setVisible(false);
                  getData();
                })
                .catch((error) => {
                  message.error("网络异常，请重试！");
                });
            })
            .catch((err) => {
              console.log("err", err);
            });
        }}
      >
        <Form labelCol={{ span: 4 }} wrapperCol={{ span: 20 }} form={form}>
          <Form.Item
            label={KEYS_TEST[KEYS.PERMISSION_NAME]}
            name={KEYS.PERMISSION_NAME}
            rules={[{ required: true, message: "请填写权限名称" }]}
          >
            <Input allowClear />
          </Form.Item>
          <Form.Item
            label={KEYS_TEST[KEYS.PERMISSION]}
            name={KEYS.PERMISSION}
            required
          >
            <Input allowClear />
          </Form.Item>
          <Form.Item label={KEYS_TEST[KEYS.ACCOUT]} name={KEYS.ACCOUT}>
            <Input allowClear />
          </Form.Item>
          <Form.Item
            label={KEYS_TEST[KEYS.ACCOUNT_TYPE]}
            name={KEYS.ACCOUNT_TYPE}
            required
            allowClear
          >
            <Input allowClear />
          </Form.Item>
          <Form.Item
            label={KEYS_TEST[KEYS.AFFILIATION]}
            name={KEYS.AFFILIATION}
            required
          >
            <Input allowClear />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
